// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"725":"98bef5de","805":"cd97a040","828":"menu-items-svg"}[chunkId] || chunkId) + "." + {"725":"07d6b827a70c706e","803":"b197c4040704ef15","805":"69c61cc3e4ebfc5b","828":"08de537641d26af4","889":"b2cf29fd2eef7dba"}[chunkId] + ".js";
};